import debounceFn from 'lodash/debounce';

export const debounce = ( milliseconds = 0, options = {} ) => {
  return ( target: any, propertyKey: string, descriptor: PropertyDescriptor ): PropertyDescriptor => {
    const originalMethod = descriptor.value;
    descriptor.value = debounceFn(originalMethod, milliseconds, options);
    return descriptor;
  };
};
